import { getSetting } from '@disy/workbook.lib/settings';

import { isClassifiable } from 'cadenza/repository/model/attribute-type.gen';
import type { RootStateOr } from 'cadenza/store/cadenza-store';
import { getStore } from 'cadenza/store/cadenza-store';
import { AttributeModificationKey } from 'cadenza/workbook/api/attribute-modification-key';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';
import { TableCellPresentation } from 'cadenza/workbook/attribute-modification-dialog/model/table-cell-presentation.gen';
import type { AttributeBundleName } from 'cadenza/workbook/model/attribute-bundle-name';
import { INDICATOR_BUNDLE_NAME } from 'cadenza/workbook/model/attribute-bundle-name';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import {
  getAttributeById,
  getAttributeIdsFromBundle,
  getDataViewById,
} from 'cadenza/workbook/workbook-core-selectors.state';
import type { WorkbookState } from 'cadenza/workbook/workbook.state';

export function getClassifiableAttributesGroupedByClassification(
  state: RootStateOr<WorkbookState>,
  dataViewId: DataViewId,
) {
  const attributesWithPresentation: WorkbookAttributeDto[] = [];
  const attributesWithoutPresentation: WorkbookAttributeDto[] = [];
  if (getDataViewById(state, dataViewId)) {
    getAttributesWithConfigurableAttributesPresentation(state, dataViewId).forEach((attribute) => {
      if (isClassifiable(attribute.type)) {
        const presentation = getAttributePresentation(attribute);
        (presentation ? attributesWithPresentation : attributesWithoutPresentation).push(attribute);
      }
    });
  }

  return {
    attributesWithPresentation,
    attributesWithoutPresentation,
  };
}

function getAttributesWithConfigurableAttributesPresentation(
  state: RootStateOr<WorkbookState>,
  dataViewId: DataViewId,
) {
  const bundles: AttributeBundleName[] = ['ROWS', 'MEASURES', 'INDIVIDUAL_COLUMNS', INDICATOR_BUNDLE_NAME];
  return bundles
    .flatMap((bundleName) => getAttributeIdsFromBundle(state, dataViewId, bundleName))
    .map((attributeId) => getAttributeById(getStore().getState(), attributeId));
}

export function getAttributePresentation(attribute: WorkbookAttributeDto): TableCellPresentation | undefined {
  const persistenceKey = getSetting<string>(attribute, AttributeModificationKey.TABLE_CELL_PRESENTATION);
  return persistenceKey ? TableCellPresentation.fromPersistenceKey(persistenceKey) : undefined;
}
